import { DomainUpsertLoadingList } from "@/components/domain";
import { useGetServiceProvider } from "@/hooks/service-providers/get.hooks";
import { useUpdateServiceProvider } from "@/hooks/service-providers/update.hooks";
import {
  CreateServiceProvider,
  ServiceProvider,
  ServiceProviderDomain,
} from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
)({
  component: RouteComponent,
  validateSearch: z.object({
    domain: z.enum(["service", "provider"]),
  }),
});

function RouteComponent() {
  const { id, spId } = Route.useParams();
  const { domain } = Route.useSearch();
  const { data: serviceProvider, isLoading } = useGetServiceProvider(
    domain,
    spId
  );
  if (isLoading || !serviceProvider) return <DomainUpsertLoadingList />;
  return <Edit domain={domain} id={id} model={serviceProvider} />;
}

function Edit({
  model,
  domain,
  id,
}: {
  model: ServiceProvider;
  id: string;
  domain: ServiceProviderDomain;
}) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateServiceProvider(domain, id, {
    onSuccess: () => {
      navigate({
        to: "/service-providers/$id",
        params: { id },
        search: { domain },
      });
    },
  });

  const update = async (serviceProvider: CreateServiceProvider) => {
    await mutateAsync({ id: model.id, ...serviceProvider });
  };
  return (
    <Form
      model={model}
      onUpsert={update}
      domain={domain}
      domainId={id}
      name={
        domain === "service"
          ? (model.provider?.name ?? "-")
          : (model.service?.name ?? "-")
      }
    />
  );
}
